import React from "react";
import PdfOpener from "../CommonComponents/Modal/PdfOpener";
import TIFFFileViewer from "../CommonComponents/TiffViewer";
import RtfViewer from "../CommonComponents/VendorUpload/RtfViewer";
import DocxOpener from "../CommonComponents/Modal/DocxOpener";
import HeicViewer from "../CommonComponents/Player/HeicViewer";
import AudioPlayer from "../CommonComponents/Player/AudioPlayer";
import VideoPlayer from "../CommonComponents/Player/VideoPlayer";
import ReactPanZoom from "react-image-pan-zoom-rotate";

const typeOfAudio = ["mp3", "wav", "ogg", "aac", "flac", "m4a"];
const typeOfPlayer = ["mp4", "webm", "mov", "avi", "mkv", "wmv", "flv"];

const DocumentRenderer = ({ selectedDoc }) => {
  if (!selectedDoc) return null;
  const ext = selectedDoc?.document_name?.split(".")?.pop()?.toLowerCase();

  if (["pdf"].includes(ext)) {
    return <PdfOpener path={selectedDoc?.document_path} type={ext} />;
  } else if (["tif", "tiff"].includes(ext)) {
    return <TIFFFileViewer tiff={selectedDoc?.document_path} />;
  } else if (["rtf"].includes(ext)) {
    return <RtfViewer rtfContent={selectedDoc?.document_path} />;
  } else if (["doc", "docx", "xlsx"].includes(ext)) {
    return <DocxOpener path={selectedDoc?.document_path} fileType={ext} />;
  } else if (["heic", "heif"].includes(ext)) {
    return <HeicViewer selectedDoc={selectedDoc} />;
  } else if (typeOfAudio.includes(ext)) {
    return <AudioPlayer src={selectedDoc?.document_path} type={ext} />;
  } else if (typeOfPlayer.includes(ext)) {
    return (
      <VideoPlayer
        width="100%"
        height="90%"
        src={selectedDoc?.document_path}
        type={ext}
      />
    );
  } else {
    return (
      <div style={{ position: "relative", overflow: "hidden" }}>
        <ReactPanZoom alt={selectedDoc?.document_path} image={selectedDoc?.document_path} />
      </div>
    );
  }
};

export default DocumentRenderer;
